import {Component, EventEmitter, inject, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {DropdownComponent, DropDownItem} from "../dropdown/dropdown.component";
import Subscription from "../../model/subscription.model";
import Relation from "../../model/relation.model";
import {AuthService} from "../../services/auth.service";
import AddressPipe from "../../pipes/address.pipe";

@Component({
    selector: 'app-subscription-selector',
    imports: [
        DropdownComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './subscription-selector.component.html'
})
export class SubscriptionSelectorComponent implements OnInit {
  private readonly authService: AuthService = inject(AuthService);

  public selectedSubscription: Subscription | null = null;
  public subscriptionItems: DropDownItem[] = [];

  @Output() selectedSubscriptionChanged: EventEmitter<Subscription> = new EventEmitter<Subscription>();

  public ngOnInit(): void {
    this.authService.getUser(['relations.subscriptions.products']).subscribe();

    this.authService.getSelectedSubscription().subscribe((subscription: Subscription | null): void => {
      if (!subscription) {
        return;
      }
      this.selectedSubscription = subscription;
    });

    this.authService.getActiveRelation().subscribe((relation: Relation | null): void => {
      if (!relation || !relation.subscriptions) {
        return;
      }

      const addressPipe: AddressPipe = new AddressPipe();
      this.subscriptionItems = relation.subscriptions.map((subscription: Subscription): DropDownItem => {
        return {
          label: subscription.id + " | " + addressPipe.transform(subscription.address),
          value: subscription
        };
      });

      if (this.subscriptionItems.length === 0) {
        return;
      }

    });
  }

  public changed(subscription: unknown): void {
    this.authService.setSelectedSubscription(subscription as Subscription);
    this.selectedSubscription = subscription as Subscription;
    this.selectedSubscriptionChanged.emit(subscription as Subscription);
  }
}
